import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import UnloggedLayout from 'v2/components/Shared/UnloggedLayout';
import subscriptionsService from 'v2/services/subscriptions';

import { useStyles } from './styles';

const SubscriptionCancel = () => {
  const classes = useStyles();
  const [pageError, setPageError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [canceling, setCanceling] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const { token } = useParams<{ token: string }>();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    (async () => {
      try {
        subscriptionsService.setToken(token);
      } catch (err) {
        setPageError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const handleClose = () => {
    window.close();
  };

  const handleSubscriptionCancel = useCallback((subscriptionId: number) => {
    setCanceling(true);
    subscriptionsService
      .subscriptionCancelMFA(subscriptionId)
      .then(() => {
        setCanceling(false);
        setCanceled(true);
        toast.success('Pedido de cancelamento enviado com sucesso.');
      })
      .catch(() => {
        setCanceling(false);
        setPageError(true);
      });
  }, []);

  const handleSubscriptionSuspend = useCallback((subscriptionId: number) => {
    setCanceling(true);
    subscriptionsService
      .subscriptionSuspendMFA(subscriptionId)
      .then(() => {
        setCanceling(false);
        setCanceled(true);
        toast.success('Pedido de suspensão enviado com sucesso.');
      })
      .catch(() => {
        setCanceling(false);
        setPageError(true);
      });
  }, []);

  if (loading) return <GlobalLoading />;
  if (pageError)
    return (
      <UnloggedLayout>
        <Grid container alignItems='center' justify='center' direction='column' className={classes.grid}>
          <div className={classes.text}>
            <Typography variant='subtitle1'>Esse link está expirado ou já foi utilizado!</Typography>
            <Typography variant='subtitle2'>Acesse o órbita para realizar esta ação.</Typography>
          </div>
        </Grid>
      </UnloggedLayout>
    );

  if (canceled)
    return (
      <UnloggedLayout>
        <Grid container alignItems='center' justify='center' direction='column' className={classes.grid}>
          <div className={classes.text}>
            <Typography variant='subtitle1'>
              Estamos trabalhando na sua solicitação.
              <br />
              Em instantes você receberá um e-mail confirmando a ação feita.
            </Typography>
          </div>
        </Grid>
      </UnloggedLayout>
    );

  return (
    <UnloggedLayout>
      <Grid container alignItems='center' justify='center' direction='column' className={classes.grid}>
        <div className={classes.text}>
          <h1>Cancelamento/suspensão de contrato</h1>
          <p>Você deseja cancelar ou suspender sua assinatura?</p>
          <div className='m24' />
          <div>
            <Button onClick={handleClose} className={classes.button}>
              Nenhum
            </Button>
            <Button
              variant='contained'
              color='primary'
              className={classes.button}
              onClick={() => handleSubscriptionSuspend(Number(id))}
              disabled={canceling}
            >
              {canceling && <CircularProgress size={10} style={{ color: '#fff', marginRight: 10 }} />}Suspender
            </Button>
            <Button
              variant='contained'
              color='primary'
              className={classes.button}
              onClick={() => handleSubscriptionCancel(Number(id))}
              disabled={canceling}
            >
              {canceling && <CircularProgress size={10} style={{ color: '#fff', marginRight: 10 }} />}Cancelar
            </Button>
          </div>
        </div>
      </Grid>
    </UnloggedLayout>
  );
};
export default SubscriptionCancel;
